module.exports = __webpack_public_path__ + "static/media/Sneaker_Male_Left_low.24f0c4d9.jpg";